export default {
  placeholder: 'Suche Marke...',
};
